import React, { useState } from 'react';
import { KeyRound, Eye, EyeOff } from 'lucide-react';
import { authAPI } from '../services/adminApi';
import './Settings.css';

const EMPTY_FORM = { oldPassword: '', newPassword: '', confirmPassword: '' };
const EMPTY_SHOW = { oldPassword: false, newPassword: false, confirmPassword: false };

const Settings = () => {
  const [form, setForm]       = useState(EMPTY_FORM);
  const [show, setShow]       = useState(EMPTY_SHOW);
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving]   = useState(false);

  const handleChange = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));
  const toggleShow    = (field) => setShow(s => ({ ...s, [field]: !s[field] }));

  const handleCancel = () => { setForm(EMPTY_FORM); setError(''); setSuccess(''); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');

    if (form.newPassword.length < 3) {
      return setError('New password must be at least 3 characters');
    }
    if (form.newPassword !== form.confirmPassword) {
      return setError('New password and confirm password do not match');
    }

    setSaving(true);
    try {
      await authAPI.changePassword({
        currentPassword: form.oldPassword,
        newPassword: form.newPassword,
      });
      setSuccess('Password updated successfully.');
      setForm(EMPTY_FORM);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update password');
    } finally {
      setSaving(false);
    }
  };

  const PasswordField = ({ label, field, placeholder, autoComplete }) => (
    <div className="admin-form-group">
      <label>{label}</label>
      <div className="admin-password-field">
        <input
          type={show[field] ? 'text' : 'password'}
          placeholder={placeholder}
          value={form[field]}
          onChange={handleChange(field)}
          autoComplete={autoComplete}
          required
        />
        <button type="button" className="admin-password-toggle" tabIndex={-1} onClick={() => toggleShow(field)}>
          {show[field] ? <Eye size={16} /> : <EyeOff size={16} />}
        </button>
      </div>
    </div>
  );

  return (
    <div className="admin-settings-page">
      <div className="admin-settings-wrap">
        <div className="admin-settings-banner">
          <div className="admin-settings-icon"><KeyRound size={20} /></div>
          <div>
            <h1>Change Password</h1>
            <p>Keep your account secure with a strong password</p>
          </div>
        </div>

        <div className="admin-settings-card">
          <form onSubmit={handleSubmit}>
            {error   && <div className="admin-auth-error">{error}</div>}
            {success && <div className="admin-settings-success">{success}</div>}

            <PasswordField label="Old Password" field="oldPassword" placeholder="Enter your current password" autoComplete="current-password" />
            <PasswordField label="New Password" field="newPassword" placeholder="Enter a new password" autoComplete="new-password" />
            <PasswordField label="Confirm New Password" field="confirmPassword" placeholder="Confirm your new password" autoComplete="new-password" />

            <div className="admin-settings-actions">
              <button type="submit" className="admin-btn-primary" disabled={saving}>
                {saving ? 'Updating…' : 'UPDATE PASSWORD'}
              </button>
              <button type="button" className="admin-btn-outline" onClick={handleCancel} disabled={saving}>
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Settings;